"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var constants_1 = require("@app/shared/constants");
var modalRootEl = document.getElementById('modal');
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.handleKeydown = function (event) {
            if (event.keyCode === constants_1.KEY_ESCAPE) {
                _this.handleClose();
            }
        };
        _this.el = document.createElement('div');
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        modalRootEl.appendChild(this.el);
        if (this.props.closeOnEscape) {
            document.addEventListener('keydown', this.handleKeydown);
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        modalRootEl.removeChild(this.el);
        if (this.props.closeOnEscape) {
            document.removeEventListener('keydown', this.handleKeydown);
        }
    };
    Modal.prototype.render = function () {
        return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "modal is-active" },
            react_1.default.createElement("div", { className: "modal-background" }),
            this.props.children), this.el);
    };
    return Modal;
}(react_2.Component));
exports.Modal = Modal;
